/**
 * RTK Query endpoint — Autocomplete
 *
 * Migrated from: src/components/autocomplete-input/actions.js
 *
 * One dynamic endpoint covering every autocomplete-style search the app does
 * (users/roles-autocomplete, resource/name-autocomplete, items/autocomplete,
 * flows/autocomplete, ...). The `resource` segment is the cache key axis;
 * each unique `resource` gets its own cache entry, dedup'd by `q`.
 */

import { baseApi } from './baseApi';

const autocompleteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    autocomplete: builder.query({
      query: ({ resource, q, ...extra }) => {
        const params = {};
        if (q != null && q !== '') params.q = q;
        Object.entries(extra).forEach(([k, v]) => {
          if (v != null) params[k] = v;
        });
        return { url: `/su/${resource}`, method: 'GET', params };
      },
      providesTags: (_result, _error, { resource }) => [
        { type: 'Autocomplete', id: resource },
      ],
      // 60s is enough to dedup rapid typing without staling the results.
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useAutocompleteQuery } = autocompleteApi;
export default autocompleteApi;
